export default __webpack_public_path__ + "static/media/view-light.7cb169aa.svg";